import { GzDarkModeToggleWebComponent } from './component/GzDarkModeToggleWebComponent';

export { GzDarkModeToggleWebComponent };
